import request from '@/utils/request'

// 保存常用应用
export const saveCommonAppsApi = (data) => request({
  url: '/bd/homepage/saveCommonApp',
  method: 'post',
  data,
  headers: { 'Content-Type': 'application/json' }
})